"use client";

import { useState } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const galleryImages = [{
  id: 1,
  url: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/restaurant_beachfront_sunset_view.png",
  alt: "Vista al atardecer desde la terraza frente al mar"
}, {
  id: 2,
  url: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/restaurant_elegant_dining_room.png",
  alt: "Elegante comedor principal con decoración contemporánea"
}, {
  id: 3,
  url: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/restaurant_ocean_terrace_seating.png",
  alt: "Terraza con vista al océano y mesas al aire libre"
}, {
  id: 4,
  url: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/restaurant_modern_bar_area.png",
  alt: "Área de bar moderna con iluminación ambiente"
}, {
  id: 5,
  url: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/restaurant_private_dining_space.png",
  alt: "Espacio privado para cenas exclusivas"
}, {
  id: 6,
  url: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/restaurant_architectural_exterior.png",
  alt: "Arquitectura exterior del restaurante"
}, {
  id: 7,
  url: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/restaurant_poolside_lounge.png",
  alt: "Lounge junto a la piscina"
}, {
  id: 8,
  url: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/restaurant_night_ambiance.png",
  alt: "Ambiente nocturno con iluminación cálida"
}, {
  id: 9,
  url: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/restaurant_entrance_pathway.png",
  alt: "Camino de entrada al restaurante"
}];
export default function Galeria() {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const {
    ref: galleryRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  const openLightbox = (index: number) => {
    setCurrentImageIndex(index);
    setLightboxOpen(true);
    document.body.style.overflow = "hidden";
  };
  const closeLightbox = () => {
    setLightboxOpen(false);
    document.body.style.overflow = "auto";
  };
  const goToPrevious = () => {
    setCurrentImageIndex(prev => prev === 0 ? galleryImages.length - 1 : prev - 1);
  };
  const goToNext = () => {
    setCurrentImageIndex(prev => prev === galleryImages.length - 1 ? 0 : prev + 1);
  };
  return <section id="galería" className="py-16 px-4 sm:px-6 lg:px-8 bg-background">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-display text-4xl md:text-5xl font-bold text-center mb-12 text-foreground">
          Galería
        </h2>

        <div ref={galleryRef} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
          {galleryImages.map((image, i) => <div key={image.id} data-index={i} className="relative aspect-[4/3] overflow-hidden rounded-md cursor-pointer group" style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? "translateY(0)" : "translateY(30px)",
          transition: `opacity 600ms ease-out ${i * 100}ms, transform 600ms ease-out ${i * 100}ms`
        }} onClick={() => openLightbox(i)}>
              <img src={image.url} alt={image.alt} className="w-full h-full object-cover transition-transform duration-500 ease-out-back group-hover:scale-110" />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300" />
            </div>)}
        </div>
      </div>

      {lightboxOpen && <div className="fixed inset-0 z-50 bg-black/95 backdrop-blur-sm flex items-center justify-center" onClick={closeLightbox}>
          <Button variant="ghost" size="icon" className="absolute top-4 right-4 text-white hover:bg-white/10 z-10" onClick={e => {
        e.stopPropagation();
        closeLightbox();
      }}>
            <X className="size-6" />
            <span className="sr-only">Cerrar galería</span>
          </Button>

          <Button variant="ghost" size="icon" className="absolute left-4 top-1/2 -translate-y-1/2 text-white hover:bg-white/10 z-10" onClick={e => {
        e.stopPropagation();
        goToPrevious();
      }}>
            <ChevronLeft className="size-8" />
            <span className="sr-only">Imagen anterior</span>
          </Button>

          <Button variant="ghost" size="icon" className="absolute right-4 top-1/2 -translate-y-1/2 text-white hover:bg-white/10 z-10" onClick={e => {
        e.stopPropagation();
        goToNext();
      }}>
            <ChevronRight className="size-8" />
            <span className="sr-only">Siguiente imagen</span>
          </Button>

          <div className="relative max-w-6xl max-h-[90vh] w-full h-full flex items-center justify-center px-16" onClick={e => e.stopPropagation()}>
            <img src={galleryImages[currentImageIndex].url} alt={galleryImages[currentImageIndex].alt} className="max-w-full max-h-full object-contain animate-fade-in-up rounded-lg" style={{
          animation: "fade-in-up 400ms ease-out"
        }} />
          </div>

          <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-white text-sm">
            {currentImageIndex + 1} / {galleryImages.length}
          </div>
        </div>}
    </section>;
}